import classNames from 'clsx';
import React, { memo } from 'react';
import type { CellProps } from 'react-table';

import type { TableColumnInstance, Tournament } from '../../../types/MTT';
import sharedStyles from '../shared.scss';

interface TableCellBaseProps extends CellProps<Tournament> {
  displayValue: React.ReactNode;
  useInnerHTML?: boolean;
}

const TableCellBase: React.FC<TableCellBaseProps> = memo(
  ({ column, displayValue, useInnerHTML = false }) => {
    const { display, width } = column as TableColumnInstance;

    return (
      <div
        className={classNames(sharedStyles.cell, {
          [sharedStyles.cellExpand]: !width
        })}
        style={{ display }}
        {...(useInnerHTML && typeof displayValue === 'string'
          ? { dangerouslySetInnerHTML: { __html: displayValue } }
          : { children: displayValue })}
      />
    );
  }
);

export default TableCellBase;
